import { ThemeMode } from '#/enum';
import { useMultiTabsContext } from '@/layouts/dashboard/multi-tabs/providers/multi-tabs-provider';
import { useSettings } from '@/store/settingStore';
import { BarChartOutlined, CalendarOutlined, LockOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { Button, Form, Input, Modal, Checkbox } from 'antd'
import axios from 'axios';
import React, { useState, useEffect } from 'react'
import { LuMailOpen } from 'react-icons/lu';
import { MdDiamond, MdLock, MdShield } from 'react-icons/md';
import { RiShieldCheckFill } from 'react-icons/ri';
import { TbDiamond, TbMoneybag } from 'react-icons/tb';
import { useNavigate } from 'react-router';
import { toast } from 'sonner';
import { useResetInterval } from '@/store/userStore';

const PaymentModal = ({open, tier_id,onClose , tier , price, amount, annualAmount, savings,  monthlyCredits, annualCredits , billingCycle, stripeProductID , myrMonthly, myrAnnual, stripePriceMonthlyId, stripePriceAnnualId}) => {

  const { themeMode } = useSettings();
  const navigate = useNavigate();
  const {closeTab} = useMultiTabsContext();

  const [isPrivacyModalOpen, setPrivacyModalOpen] = useState(false);

  const [selectedPricing , setSelectedPricing] = useState(billingCycle === "yearly" ? "annually" : "monthly");
  const [agreed, setAgreed] = useState(false)
  const [loadingButton, setLoadingButton] = useState(false);
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [paymentUrl, setPaymentUrl] = useState("");
  const [paymentBillingID, setPaymentBillingID] = useState();

  const URL = import.meta.env.VITE_AGENT_URL;
  const { VITE_APP_URL: APP_URL } = import.meta.env;
  const userId = localStorage.getItem("userId");
  const resetInterval = useResetInterval();
  const isAnnualReset = resetInterval === 'annual' || resetInterval === 'annually';

  useEffect(() => {
    if (open) {
      if (isAnnualReset) {
        setSelectedPricing("annually");
      } else {
        setSelectedPricing(billingCycle === "yearly" ? "annually" : "monthly");
      }
    }
  }, [open, billingCycle, isAnnualReset]);

  const dynamicMyrAmount = selectedPricing === "monthly" ? myrMonthly : myrAnnual;
  const dynamicCredits = selectedPricing === "monthly" ? monthlyCredits : annualCredits;

  const handlePay = async()=>{
    try {

      if(!email || !fullName){
        toast.error("Please enter your full name and email")
        return;
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        toast.error("Please enter a valid email address");
        return;
      }
      setLoadingButton(true);
      
      // const response = await axios.post(`${APP_URL}/api/payments/create`,
      //        {
      //         "user_id": Number(userId),
      //         "tier_id": tier_id,
      //         "name": fullName,
      //         "email": email,
      //         "amount_myr": selectedPricing === "monthly"? myrMonthly: myrAnnual,
      //         // "amount": selectedPricing === "monthly"? myrMonthly: myrAnnual,
      //         // "description": `Vantage AI ${tier} Plan (${selectedPricing === "monthly"? "Monthly" : "Annual"})`,
      //         // "plan": tier,
      //         "billing_cycle": selectedPricing === "annually" ? "annual" : selectedPricing,
      //         "bank_code": null
      //     },
      //     {
      //       headers: {
      //         "Content-Type": "application/json",
      //       }
      // })

      const response = await axios.post(`${APP_URL}/api/payments/stripe/create-checkout-session`,{
        "user_id": Number(userId),
        "email": email,
        "name": fullName,
        "tier_id": tier_id,
        "billing_cycle": selectedPricing === "annually" ? "annually" : selectedPricing,
        "price_id": selectedPricing === "annually" ? stripePriceAnnualId : stripePriceMonthlyId,
        "product_id": stripeProductID,
      })

      const newPaymentUrl = response?.data?.payment_url;
      const newPaymentBillingID = response?.data?.bill_id;
      const newTransactionId = response?.data?.transaction_id;
      setPaymentUrl(newPaymentUrl)
      setPaymentBillingID(newPaymentBillingID)

      if (newTransactionId) {
        sessionStorage.setItem('active_transaction_id', newTransactionId);
      }

      setLoadingButton(false)

       localStorage.setItem('pending_payment', JSON.stringify({
         bill_id: newPaymentBillingID,
         plan: tier,
         price: selectedPricing === "monthly" ? price : `${"$" + annualAmount}`,
         credits: dynamicCredits,
         billingCycle: selectedPricing,
         email: email,
         tier_id: tier_id,
         timestamp: Date.now()
       }));

       onClose();
       navigate(`/dashboard/redirecting-to-payment-partner?plan=${tier}&price=${selectedPricing === "monthly"?price:`${"$" + annualAmount}`}&credits=${dynamicCredits}&billingCycle=${selectedPricing}&tier_id=${tier_id}`,{state: {name: fullName , email: email, payment_url: newPaymentUrl, bill_id: newPaymentBillingID }});
       
    } catch (error) {
        console.error("Payment initiation error:", error);
        localStorage.removeItem('pending_payment');
        sessionStorage.removeItem('active_transaction_id');
        toast.error("Failed to initiate payment. Please try again.");
    } finally {
        setLoadingButton(false);
    }
  }

  return (
    <Modal open={open} onCancel={onClose} footer={null} style={{ top: 20 }} width={500} 
      maskClosable={false}
      styles={{
        content: {
          backgroundColor: themeMode === ThemeMode.Dark ? '#0f172a' : '#ffffff',
        }
      }}
    >
        <div className='w-full flex flex-col gap-4 p-1 dark:text-white'>
          {/* Title Section */}
          <div className='w-full flex gap-4 items-center'>
            <div className='w-[60px] h-[60px] rounded-xl flex items-center justify-center' style={{backgroundColor: themeMode === ThemeMode.Dark ? "rgba(196,18,48,0.1)" : "rgba(196,18,48,0.05)"}}>
                   {
                    tier === "starter" ?                     <svg width="18" height="11" viewBox="0 0 18 11" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.15104 10.4497L0 9.29867L6.34201 2.95665L9.77257 6.38721L14.5573 1.62505H11.9167V5.43594e-05H17.3333V5.41672H15.7083V2.7761L9.77257 8.68929L6.34201 5.25873L1.15104 10.4497Z" fill="#C41230"/>
</svg>: <MdDiamond style={{fontSize:"28px",color: "#C41230"}}/>
                   }
                </div>
                <div className='flex flex-col gap-1'>
                  <h1 className='text-lg font-bold capitalize dark:text-white'>Upgrade to {tier}</h1>
                  <span className='text-sm font-semibold text-gray-700 dark:text-gray-300'>You are upgrading to the <b className='capitalize text-primary text-[14px]'>{tier}</b> plan</span>
                </div>
          </div>

          {/* Second Box Section */}
          <div className='w-full border rounded-lg p-3 border-[#C4123020] dark:border-[#C4123040] shadow-sm flex flex-col gap-4 items-center justify-center' style={{backgroundColor: themeMode === ThemeMode.Dark ? "rgba(196,18,48,0.1)" : "rgba(196,18,48,0.05)"}}>

            <div className='w-full flex justify-between px-4'>
              <div className='flex flex-col gap-3'>
               <div className='flex items-center gap-2'>
                  <div className='w-[25px] h-[25px] rounded-md flex items-center justify-center' style={{backgroundColor: themeMode === ThemeMode.Dark ? "rgba(196,18,48,0.1)" : "rgba(196,18,48,0.20)"}}>
                    <LuMailOpen style={{fontSize:"12px",color: "#C41230"}}/>
                  </div>
                  <span className='font-semibold text-gray-700 dark:text-gray-300'>Plan</span>
               </div>
               <span className='text-xl font-bold capitalize dark:text-white'>{tier}</span>
              </div>

              <div className='flex flex-col gap-3 border-l-[1.5px] border-black/10 dark:border-white/10 pl-3'>
               <div className='flex items-center gap-2'>
                  <div className='w-[25px] h-[25px] rounded-md flex items-center justify-center' style={{backgroundColor: themeMode === ThemeMode.Dark ? "rgba(196,18,48,0.1)" : "rgba(196,18,48,0.20)"}}>
                    <TbMoneybag style={{fontSize:"12px",color: "#C41230"}}/>
                  </div>
                  <span className='font-semibold text-gray-700 dark:text-gray-300'>Credits</span>
               </div>
               <span className='text-xl font-bold capitalize dark:text-white'>{dynamicCredits}</span>
              </div>

             <div className='flex flex-col gap-3 border-l-[1.5px] border-black/10 dark:border-white/10 pl-3'>
               <div className='flex items-center gap-2'>
                  <div className='w-[25px] h-[25px] rounded-md flex items-center justify-center' style={{backgroundColor: themeMode === ThemeMode.Dark ? "rgba(196,18,48,0.1)" : "rgba(196,18,48,0.20)"}}>
                    <CalendarOutlined style={{fontSize:"12px",color: "#C41230"}}/>
                  </div>
                  <span className='font-semibold text-gray-700 dark:text-gray-300'>Billing Cycle</span>
               </div>
               <span className='text-xl font-bold capitalize dark:text-white'>{selectedPricing === "monthly" ? "Monthly" : "Annual"}</span>
              </div>
            </div>

            <div className="w-full bg-black/10 dark:bg-white/10 h-[1.1px]" />

            <div className='px-4 w-full flex flex-col gap-4'>
                <span className='text-gray-700 font-semibold dark:text-gray-300'>Price</span>
                <span className='text-center text-gray-700 font-semibold dark:text-gray-300'><b className='font-bold text-[#C41230] text-3xl'>${selectedPricing === "monthly" ? amount/100 : annualAmount/100}</b>{selectedPricing === "monthly" ? "/month" : "/year"}</span>
            </div>
            
          </div>

          {/* Select Yearly or Monthly */}
          <div className='w-full flex items-center gap-2'>
              <div className='w-1/2 h-[145px] p-4 border  rounded-lg flex flex-col justify-center gap-2 transition-all duration-300' title={isAnnualReset ? "Cannot downgrade to monthly on an active annual plan" : ""} style={{cursor: isAnnualReset ? "not-allowed" : "pointer", opacity: isAnnualReset ? 0.5 : 1, borderColor: selectedPricing === "monthly" ? "#C41230" : (themeMode === ThemeMode.Dark ? "#334155" : "#E2E8F0"),backgroundColor: selectedPricing === "monthly"?(themeMode === ThemeMode.Dark ? "rgba(196,18,48,0.1)" : "rgba(196,18,48,0.05)"):"transparent"}} onClick={() => {
                if (isAnnualReset) return;
                setSelectedPricing("monthly");
              }}>
                  <div className='size-4 rounded-full border  flex items-center justify-center  p-[2px]' style={{borderColor: selectedPricing === "monthly"?"#C41230":(themeMode === ThemeMode.Dark ? "#475569" : "#E2E8F0")}}>
                          {
                            selectedPricing === "monthly" && (
                              <div className='w-full h-full rounded-full bg-[#C41230]'></div>
                            )
                          }
                   </div>
                   <span className='capitalize font-bold text-[14px] dark:text-white'>{tier} monthly</span>

                   <div className='flex flex-col -gap-1'>
                    <span className='font-bold text-[16px] dark:text-white'>${amount/100}</span>
                    <span className='font-semibold text-gray-600 dark:text-gray-400'>Billed monthly</span>
                   </div>
              </div>
              <div className='w-1/2 h-[145px] p-4 border  rounded-lg cursor-pointer flex flex-col justify-center gap-2 transition-all duration-300' style={{borderColor: selectedPricing === "annually" ? "#C41230" : (themeMode === ThemeMode.Dark ? "#334155" : "#E2E8F0"),backgroundColor: selectedPricing === "annually"?(themeMode === ThemeMode.Dark ? "rgba(196,18,48,0.1)" : "rgba(196,18,48,0.05)"):"transparent"}}  onClick={()=>setSelectedPricing("annually")}>
                  
                  <div className='w-full flex items-center justify-between'>
                     <div className='size-4 rounded-full border  flex items-center justify-center p-[2px]' style={{borderColor: selectedPricing === "annually"?"#C41230":(themeMode === ThemeMode.Dark ? "#475569" : "#E2E8F0")}}>
                          {
                            selectedPricing === "annually" && (
                              <div className='w-full h-full rounded-full bg-[#C41230]'></div>
                            )
                          }
                   </div>
                   <div className='px-2 py-1 rounded-full text-sm bg-[#C41230] flex items-center justify-center font-bold text-white'>
                    <span>Save {savings}%</span>
                   </div>
                  </div>


                   <span className='capitalize font-bold text-[14px] dark:text-white'>{tier} annual</span>

                   <div className='flex flex-col -gap-1'>
                    <span className='font-bold text-[16px] dark:text-white'>${annualAmount/100}</span>
                    <span className='font-semibold text-gray-600 dark:text-gray-400'>Billed yearly</span>
                   </div>
              </div>
              
          </div>

          <div className='w-full flex flex-col gap-1 mt-2'>
            <h2 className='font-bold text-[16px] dark:text-white'>Billing Details</h2>
            <span className='text-gray-700 font-medium text-[12px] dark:text-gray-400'>Please provide your details to continue.</span>
          </div>

         <div className=' w-full flex items-center gap-4'>
           <Form.Item layout='vertical' style={{width:"50%"}} label={<span className='font-semibold text-black dark:text-gray-200'>Full Name</span>}>
            <Input
              placeholder='Enter your full name'
              style={{
                borderColor: themeMode === ThemeMode.Dark ? '#475569' : '#00000030',
                backgroundColor: themeMode === ThemeMode.Dark ? 'transparent' : undefined,
                color: themeMode === ThemeMode.Dark ? '#fff' : undefined,
                borderWidth: '1.5px',
                padding: '10px',
                borderRadius: '8px',
              }}
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
            /> 
              
          </Form.Item>

          <Form.Item layout='vertical' style={{width:"50%"}} label={<span className='font-semibold text-black dark:text-gray-200'>Email Address</span>} >
            <Input
              placeholder='Enter your email address'
              style={{
                borderColor: themeMode === ThemeMode.Dark ? '#475569' : '#00000030',
                backgroundColor: themeMode === ThemeMode.Dark ? 'transparent' : undefined,
                color: themeMode === ThemeMode.Dark ? '#fff' : undefined,
                borderWidth: '1.5px',
                padding: '10px',
                borderRadius: '8px',
              }}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            /> 
              
          </Form.Item>
         </div>

          {/* Recurring Payment Note */}
          <div className='w-full border rounded-lg p-3 shadow-sm flex flex-col gap-1 -mt-4' style={{borderColor: themeMode === ThemeMode.Dark ? "rgba(234,179,8,0.2)" : "rgba(234,179,8,0.5)", backgroundColor: themeMode === ThemeMode.Dark ? "rgba(234,179,8,0.1)" : "rgba(234,179,8,0.05)"}}>
            <div className='flex items-center gap-2'>
              <InfoCircleOutlined style={{color: "#eab308", fontSize: "16px"}} />
              <span className='font-semibold text-[13px] text-black dark:text-gray-300'>Note about recurring payment</span>
            </div>
            <span className='text-gray-700 dark:text-gray-400 text-[12px] ml-6'>
              This is a recurring payment. You will be charged ${selectedPricing === "monthly" ? amount/100 : annualAmount/100} every {selectedPricing === "monthly" ? "month" : "year"} until you cancel. You can manage or cancel your subscription anytime from billing settings.
            </span>
          </div>

          {/* Exchange Rate Note */}
          <div className='w-full border rounded-lg p-3 shadow-sm flex flex-col gap-1' style={{borderColor: themeMode === ThemeMode.Dark ? "rgba(59,130,246,0.2)" : "rgba(59,130,246,0.5)", backgroundColor: themeMode === ThemeMode.Dark ? "rgba(59,130,246,0.1)" : "rgba(59,130,246,0.05)"}}>
            <div className='flex items-center gap-2'>
              <InfoCircleOutlined style={{color: "#3b82f6", fontSize: "16px"}} />
              <span className='font-semibold text-[13px] text-black dark:text-gray-300'>Note about exchange rates</span>
            </div>
            <span className='text-gray-700 dark:text-gray-400 text-[12px] ml-6'>
              Based on current myr exchange rate you will be charged
            </span>
          </div>

          {/* Box payment partner */}
          {/* <div className='w-full h-12 border rounded-lg  border-[#C4123020] shadow-sm flex gap-2 items-center justify-center' style={{backgroundColor: themeMode === ThemeMode.Dark ? "rgba(196,18,48,0.1)" : "rgba(196,18,48,0.05)"}}>
            <MdLock style={{color:"#C41230", fontSize:"18px"}}/>
            <span className='text-gray-600 font-semibold text-[11px] '>Your payment will be processed securely via our trusted payment partner.</span>
          </div> */}

          <div className='w-full flex items-center justify-center mt-2'>
            <Checkbox checked={agreed} onChange={(e) => setAgreed(e.target.checked)}>
              <span className='text-gray-600 dark:text-gray-300 font-medium text-[13px]'>I agree to proceed with Stripe and accept <Button type='link' style={{marginLeft:"-15px"}} onClick={()=>setPrivacyModalOpen(true)}>Privacy Policy</Button>.</span>
            </Checkbox>
          </div>

            {/* Button */}
            <Button block disabled={!agreed} loading={loadingButton} type='primary' size='large' className='mt-2' style={{fontWeight:"bold"}} onClick={handlePay}>Pay ${selectedPricing === "monthly" ? amount/100 : annualAmount/100} & Continue</Button>

            {/* Last */}
            {/* <div className='w-full flex items-center justify-center gap-2 '>
              <RiShieldCheckFill className='text-gray-600'/>
              <span className='text-gray-600 font-medium text-sm'>You can cancel or change your plan anytime from billing settings.</span>
            </div> */}

              <Modal
                    title={<span className="text-xl font-bold">Privacy Policy for Valiantlytix Sdn. Bhd.</span>}
                    open={isPrivacyModalOpen}
                    onCancel={() => setPrivacyModalOpen(false)}
                    footer={[
                      <Button key="close" type="primary" onClick={() => setPrivacyModalOpen(false)} className="!bg-[#A91D22] hover:!bg-[#8a171b] !border-none">
                        Close
                      </Button>
                    ]}
                    width={800}
                    centered
                  >
                    <div className="text-gray-700 text-[14px] space-y-4 max-h-[65vh] overflow-y-auto pr-2 py-2">
                      <p><strong>Effective Date:</strong> April 2, 2026 &nbsp;|&nbsp; <strong>Last Updated:</strong> April 2, 2026</p>
                      
                      <p>At Valiantlytix Sdn. Bhd. ("Valiantlytix", "we", "us", or "our"), we specialize in AI transformation and data analytics. We understand that your data is a valuable asset, and we are committed to protecting your privacy. This policy outlines how we handle your personal data when you visit our website, use our Contact Us form, or subscribe to our communications.</p>
            
                      <h3 className="font-bold text-[16px] text-gray-900 mt-5">1. Personal Data We Collect</h3>
                      <p>We collect information that identifies you or allows us to contact you, including:</p>
                      <ul className="list-disc pl-6 space-y-1">
                        <li><strong>Identity & Contact Data:</strong> Name, job title, company name, email address, and phone number.</li>
                        <li><strong>Inquiry Data:</strong> Any specific information or project details you provide in the message field of our contact forms.</li>
                        <li><strong>Technical & Usage Data:</strong> IP address, browser type, and interactions with our website (collected via cookies) to optimize your user experience.</li>
                      </ul>
            
                      <h3 className="font-bold text-[16px] text-gray-900 mt-5">2. Purpose of Data Processing</h3>
                      <p>In compliance with the Notice and Choice Principle of the PDPA, we process your data for:</p>
                      <ul className="list-disc pl-6 space-y-1">
                        <li><strong>Direct Inquiry Fulfillment:</strong> Responding to your requests for AI solutions, proposals, or training services.</li>
                        <li><strong>Relationship Management:</strong> Scheduling discovery calls and managing business interactions.</li>
                        <li><strong>Marketing & Engagement:</strong> Sending you newsletters, whitepapers, and updates regarding AI trends and Valiantlytix services.</li>
                        <li><strong>Analytics:</strong> Using anonymized data to improve our service offerings and website performance.</li>
                      </ul>
            
                      <h3 className="font-bold text-[16px] text-gray-900 mt-5">3. Marketing Communications & Newsletters</h3>
                      <p>By providing your contact details and opting in, you agree to receive marketing materials from us.</p>
                      <ul className="list-disc pl-6 space-y-1">
                        <li><strong>Personalization:</strong> We may use automated analytics to ensure the insights and newsletters we send are relevant to your industry or interests.</li>
                        <li><strong>Opt-out (Unsubscribe):</strong> You have the right to stop receiving marketing emails at any time. Every newsletter or promotional email includes an "Unsubscribe" link. Alternatively, you may contact our DPO to be removed from our mailing list.</li>
                      </ul>
            
                      <h3 className="font-bold text-[16px] text-gray-900 mt-5">4. Consent</h3>
                      <p>By submitting your information through our website, you explicitly consent to the processing of your personal data as described.</p>
            
                      <h3 className="font-bold text-[16px] text-gray-900 mt-5">5. Disclosure of Your Data</h3>
                      <p>We do not sell, rent, or trade your personal data. We only share information with:</p>
                      <ul className="list-disc pl-6 space-y-1">
                        <li><strong>Authorized Personnel:</strong> Employees within Valiantlytix who require the data to assist you.</li>
                        <li><strong>Trusted Data Processors & Affiliates:</strong> Third-party providers and affiliates (such as CRM platforms or cloud storage) used to support AI-driven processing and core site functionalities. All providers are contractually bound to maintain strict confidentiality.</li>
                        <li><strong>Legal Compliance:</strong> Regulatory bodies or law enforcement when required by Malaysian law.</li>
                      </ul>
            
                      <h3 className="font-bold text-[16px] text-gray-900 mt-5">6. Data Security & Integrity</h3>
                      <p>As an AI-driven organization, we employ high-standard technical and organizational measures to protect your data from unauthorized access, alteration, or disclosure. We utilize encryption and secure access protocols to maintain data integrity.</p>
            
                      <h3 className="font-bold text-[16px] text-gray-900 mt-5">7. Data Retention</h3>
                      <p>We retain your personal data only as long as necessary to fulfill the purposes outlined in this policy or to meet legal and regulatory requirements. Once no longer needed, data is securely deleted or permanently anonymized.</p>
            
                      <h3 className="font-bold text-[16px] text-gray-900 mt-5">8. Your Rights under PDPA 2024</h3>
                      <p>You have the following rights regarding your personal data:</p>
                      <ul className="list-disc pl-6 space-y-1">
                        <li><strong>Access & Correction:</strong> The right to request a copy of your data or correct any inaccuracies.</li>
                        <li><strong>Withdrawal of Consent:</strong> The right to stop us from processing your data for marketing or other purposes.</li>
                        <li><strong>Data Portability:</strong> The right to request your data in a structured, machine-readable format.</li>
                        <li><strong>Automated Decision-Making:</strong> The right to request human intervention regarding any automated profiling that significantly affects you.</li>
                      </ul>
            
                      <h3 className="font-bold text-[16px] text-gray-900 mt-5">9. User-Generated Content License</h3>
                      <p>By submitting content to our site (such as comments, reviews, or images), you grant Valiantlytix a non-exclusive, royalty-free, worldwide license to use, modify, and distribute that content to operate, promote, and improve our services.</p>
            
                      <h3 className="font-bold text-[16px] text-gray-900 mt-5">10. Data Protection Officer (DPO)</h3>
                      <p>In accordance with the Personal Data Protection (Amendment) Act 2024, we have appointed a Data Protection Officer. For any questions, data access requests, or complaints, please contact:</p>
                      <div className="bg-gray-50 border border-gray-200 p-4 rounded-lg mt-3 text-sm">
                        <p className="mb-1"><strong>Attn:</strong> Data Protection Officer</p>
                        <p className="mb-1"><strong>Valiantlytix Sdn. Bhd.</strong></p>
                        <p className="mb-1"><strong>Email:</strong> legal@valiantlytix.com</p>
                        <p className="mb-0"><strong>Location:</strong> Petaling Jaya, Selangor, Malaysia</p>
                      </div>
            
                      <h3 className="font-bold text-[16px] text-gray-900 mt-5">11. Amendments</h3>
                      <p>We reserve the right to update this policy to reflect changes in our business practices or Malaysian law. Updates will be posted on this page with a revised "Last Updated" date.</p>
                    </div>
                  </Modal>
            
        </div>
    </Modal>
  )
}

export default PaymentModal